import { render, staticRenderFns } from "./One_slot.vue?vue&type=template&id=3d67c8e8&"
import script from "./One_slot.vue?vue&type=script&lang=js&"
export * from "./One_slot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports